<script>
  import { t } from '../i18n/index.js';
  import { showScreen } from '../stores/screen.js';

  let {
    title = '',
    message = '',
    onRetry = () => showScreen('camera'),
    showReportButton = true
  } = $props();

  let showReportDialog = $state(false);

  function handleReport() {
    // TODO: Implement report dialog
    showReportDialog = true;
  }
</script>

<div class="screen flex flex-col h-full items-center justify-center p-8">
  <div class="text-center">
    <div class="mb-6">
      <svg class="h-20 w-20 mx-auto text-red-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
      </svg>
    </div>
    <h2 class="text-2xl font-bold mb-3">{title || t('error.title')}</h2>
    <p class="text-gray-400 text-lg mb-8 whitespace-pre-line">{message || t('error.message')}</p>
    <button
      onclick={onRetry}
      class="btn-large py-4 px-10 bg-blue-600 hover:bg-blue-500 rounded-xl font-bold text-lg transition-colors"
    >
      {t('error.retry')}
    </button>
    {#if showReportButton}
      <button
        onclick={handleReport}
        class="mt-4 py-3 px-6 bg-gray-700 hover:bg-gray-600 rounded-xl font-medium transition-colors text-gray-300"
      >
        {t('error.report')}
      </button>
    {/if}
  </div>
</div>

<style>
  .screen {
    display: flex;
  }

  .btn-large {
    min-height: 60px;
    font-size: 1.125rem;
  }
</style>
